export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appHead = {"link":[{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@400;700&display=swap"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest"}],"meta":[{"name":"app-version","content":"1.0.2"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"Get expert online medical consultations from Norway-based doctors. Cardioteam offers telemedicine, diagnostics, and personalized virtual healthcare."},{"name":"author","content":"Cardioteam"},{"name":"keywords","content":"online clinic, virtual healthcare, telemedicine, doctors, medical services"},{"property":"og:title","content":"Cardioteam - Online Clinic"},{"property":"og:description","content":"Take care of your health with expert medical service from your home or anywhere."},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://www.cardioteam.no"},{"property":"og:image","content":"/images/girl_home.jpg"},{"property":"og:image:alt","content":"Default image for all links"},{"property":"og:locale","content":"en_US"},{"property":"og:site_name","content":"Cardioteam"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Cardioteam - Online Clinic"},{"name":"twitter:description","content":"Take care of your health with expert medical service from your home or anywhere."},{"name":"twitter:image","content":"/images/girl_home.jpg"},{"name":"twitter:image:alt","content":"Default image for all links"},{"name":"twitter:site","content":"@Cardioteam"},{"name":"twitter:creator","content":"@Cardioteam"},{"name":"robots","content":"index, follow"},{"name":"googlebot","content":"index, follow"},{"name":"bingbot","content":"index, follow"},{"name":"theme-color","content":"#ffffff"},{"name":"application-name","content":"Cardioteam"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"/icons/mstile-150x150.png"},{"name":"msapplication-config","content":"/browserconfig.xml"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"apple-mobile-web-app-title","content":"Cardioteam"},{"name":"msvalidate.01","content":"E4E30961DFA20C754B1F21B9203732E8"},{"name":"yandex-verification","content":"2fe5fe2e279ae076"}],"style":[],"script":[],"noscript":[],"title":"Online Doctor & Virtual Clinic in Norway | Cardioteam","htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 5000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true